import { UserModifiableEntityRepository } from './generic'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { BillingProfile } from '@backend/domain'

@Injectable()
export class BillingProfileRepository extends UserModifiableEntityRepository<BillingProfile> {
	constructor(@InjectRepository(BillingProfile) override readonly _repository: Repository<BillingProfile>) {
		super(_repository)
	}
}
